'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})
exports.InputTextarea = exports.InputSelect = undefined

var _extends =
  Object.assign ||
  function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i]
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key]
        }
      }
    }
    return target
  }

var _templateObject = _taggedTemplateLiteral(
  [
    '\n  appearance: none;\n  display: block;\n  vertical-align: middle;\n  max-width: 32rem;\n  min-height: 36px;\n  line-height: inherit;\n  font-family: inherit;\n  background-color: transparent;\n  border-radius: ',
    ';\n  border-width: 1px;\n  border-style: solid;\n  border-color: ',
    ';\n  transition: 0.125s box-shadow ease-out;\n\n  ::placeholder {\n    color: ',
    ';\n  }\n\n  ::-ms-clear {\n    display: none;\n  }\n\n  &:focus {\n    outline: none;\n    border-color: ',
    ';\n    box-shadow: 0 0 0 2px ',
    ";\n  }\n\n  &[type='select'] {\n    background: #fff url(\"data:image/svg+xml;charset=utf8,",
    '") no-repeat right .75rem center;\n    background-size: .5rem;\n  }\n\n  ',
    ' ',
    ' ',
    ' ',
    ';\n'
  ],
  [
    '\n  appearance: none;\n  display: block;\n  vertical-align: middle;\n  max-width: 32rem;\n  min-height: 36px;\n  line-height: inherit;\n  font-family: inherit;\n  background-color: transparent;\n  border-radius: ',
    ';\n  border-width: 1px;\n  border-style: solid;\n  border-color: ',
    ';\n  transition: 0.125s box-shadow ease-out;\n\n  ::placeholder {\n    color: ',
    ';\n  }\n\n  ::-ms-clear {\n    display: none;\n  }\n\n  &:focus {\n    outline: none;\n    border-color: ',
    ';\n    box-shadow: 0 0 0 2px ',
    ";\n  }\n\n  &[type='select'] {\n    background: #fff url(\"data:image/svg+xml;charset=utf8,",
    '") no-repeat right .75rem center;\n    background-size: .5rem;\n  }\n\n  ',
    ' ',
    ' ',
    ' ',
    ';\n'
  ]
)

var _react = require('react')

var _react2 = _interopRequireDefault(_react)

var _styledComponents = require('styled-components')

var _styledComponents2 = _interopRequireDefault(_styledComponents)

var _styledSystem = require('styled-system')

var _theme = require('./theme')

var _theme2 = _interopRequireDefault(_theme)

var _propTypes = require('prop-types')

var _propTypes2 = _interopRequireDefault(_propTypes)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(
    Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })
  )
}

var chevron = function chevron() {
  var props = "xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'"
  var slate = '%23' + _theme2.default.colors.slate.replace('#', '')
  var pathProps = "fill='" + slate + "' d='M2 0L0 2h4zm0 5L0 3h4z'"
  return '%3Csvg ' + props + '%3E%3Cpath ' + pathProps + '/%3E%3C/svg%3E'
}

var Base = function Base(props) {
  var next = (0, _theme.filterProps)(props)
  return _react2.default.createElement('input', next)
}

var Input = (0, _styledComponents2.default)(Base)(
  _templateObject,
  function(props) {
    return props.theme.radius
  },
  function(props) {
    return props.theme.colors.smoke
  },
  function(props) {
    return props.theme.colors.grey
  },
  function(props) {
    return props.theme.colors.info
  },
  function(props) {
    return props.theme.colors.blue[2]
  },
  chevron(),
  _styledSystem.fontSize,
  _styledSystem.space,
  _styledSystem.width,
  _styledSystem.color
)

Input.displayName = 'Input'

Input.propTypes = _extends(
  {
    id: _propTypes2.default.string
  },
  _styledSystem.propTypes.fontSize,
  _styledSystem.propTypes.space,
  _styledSystem.propTypes.width,
  _styledSystem.propTypes.color
)

Input.defaultProps = {
  theme: _theme2.default,
  w: 1,
  m: 0,
  py: 1,
  px: 2,
  fontSize: 2,
  color: 'inherit',
  bg: 'transparent'
}

var InputSelect = (exports.InputSelect = Input.withComponent('select'))
var InputTextarea = (exports.InputTextarea = Input.withComponent('textarea'))

exports.default = Input



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/Input.js
// module id = 122
// module chunks = 168707334958949